<template>
	<div class="goods">
       <v-head :title="title"></v-head>
	   <div class="means">
	   	<div class="means_top">
	      <template>
	        <img src="../../assets/images/user/default_tx.png" class="portrait" />
	      </template>
	      <div class="means_name">
	       <p>您好，欢迎您的登录！</p>
	       <p>用户名称：{{userInfo.name || '-'}}</p>
	      </div>
	      
	    </div>
	    <div class="mean_bottom">
	     <div class="left_c">
	     	<p>会员类型：{{getMemberType(userInfo.memberType) || '网员'}}</p>
	     	<p>会员编号：{{userInfo&&userInfo.memberNo || '未生成会员号'}}</p>
	     </div>	
	     <span class="more">有效期至：{{formatTime(userInfo.expiryDate) || '未成为正式会员'}}</span>
	    <!--  <van-button round type="danger">成为会员</van-button> -->
	    </div>
	   </div>
       <div class="menu">
		<van-row>
		  <van-col span="12">
		  	<div @click="go('EnrolledMeeting')">
		  	 <img src="../../assets/images/baoming.png">
		  	 <span>已报名会议</span>
		  	</div>
		  </van-col>
		  <van-col span="12" style="border-left:#dfdfdf solid 1px;">
		  	<div @click="go('payMeeting')">
		  	 <img src="../../assets/images/weibiaoti--.png">
		  	 <span>会议缴费列表</span>
		    </div>
		  </van-col>
<!-- 		  <van-col span="8">
		  	<div @click="go('PaperList')">
		   	 <img src="../../assets/images/fabiaolunwen.png">
		  	 <span>会议论文列表</span>
		  	</div>
		  </van-col> -->
		</van-row>
     </div>
     <div class="content">

        <ul id="normaltab1" class="tabbtn">
          <!-- <li :class="{'current': type === 'all'}" @click="type = 'all'">
            <a>全部会议</a>
          </li> -->
          <li :class="{'current': type === 'starting'}" @click="type = 'starting'">
            <a>正在报名</a>
          </li>
          <li :class="{'current': type === 'ready'}" @click="type = 'ready'">
            <a>会议预告</a>
          </li>
          <li :class="{'current': type === 'over'}" @click="type = 'over'">
            <a>已经结束</a>
          </li>
        </ul>
      <div class="list">
        <p class="warmTip" v-if="list.content && !list.content.length">没有数据了～</p>
         <ul class="meeting_box"> 
		  	  <li v-for="(item,index) in list.content" :key="index" >
		  	  	<span class="imgBox"><img :src="item.photoId" alt class></span>
		  	  	<div class="fonts">
					<h4 >{{item.name}}</h4>
					<p>举办时间： {{item.startDate | limitDate}}至{{item.endDate | limitDate}}</p>
					<p>报名时间： {{item.registerStartDate | limitDate}}至{{item.registerEndDate | limitDate}}</p>
					<p>举办地点： {{item.provinceName}}<template
							v-if="item.provinceName !== item.cityName "
					>{{item.cityName}}</template>
						{{item.address}}</p>
		  	  	</div>
		  	  	 <van-button round type="danger"  @click="goDetail(item.id)">查看详情</van-button>
		  	  </li>
		  	</ul>
      </div>
<!-- 		<van-tabs @change="chufa">
		  <van-tab title="全部会议" name="all" @click="type = 'all'">
		  	<ul class="meeting_box"> 
		  	  <li v-for="(item,index) in list.content" :key="index" v-if="type=='all'">
		  	  	<span class="imgBox"><img :src="item.photoId" alt class></span>
		  	  	<div class="fonts">
					<h4 >{{item.name}}</h4>
					<p>举办时间： {{item.startDate | limitDate}}至{{item.endDate | limitDate}}</p>
					<p>报名时间： {{item.registerStartDate | limitDate}}至{{item.registerEndDate | limitDate}}</p>
					<p>举办地点： {{item.provinceName}}<template
							v-if="item.provinceName !== item.cityName "
					>{{item.cityName}}</template>
						{{item.address}}</p>
		  	  	</div>
		  	  	 <van-button round type="danger"  @click="goDetail(item.id)">查看详情</van-button>
		  	  </li>
		  	</ul>
		  </van-tab>
		  <van-tab title="即将开始" name="ready" @click="type = 'ready'">
		  	<ul class="meeting_box">
		  	  <li v-for="(item,index) in list.content" :key="index" v-if="type=='ready'">
		  	  	<span class="imgBox"><img :src="item.photoId" alt class></span>
		  	  	<div class="fonts">
					<h4>{{item.name}}</h4>
					<p>举办时间： {{item.startDate | limitDate}}至{{item.endDate | limitDate}}</p>
					<p>报名时间： {{item.registerStartDate | limitDate}}至{{item.registerEndDate | limitDate}}</p>
					<p>举办地点： {{item.provinceName}}</p>
		  	  	</div>
		  	  	 <van-button round type="danger"   @click="goDetail">查看详情</van-button>
		  	  </li>
		  	</ul>
		  </van-tab>
		  <van-tab title="已经结束" name="over" @click="type = 'over'">
		  	<ul class="meeting_box">
		  	  <li v-for="(item,index) in list.content" :key="index" v-if="type=='over'">
		  	  	<span class="imgBox"><img :src="item.photoId" alt class></span>
		  	  	<div class="fonts">
		  	  		<h4>{{item.name}}</h4>
		  	  		<p>举办时间： {{item.startDate | limitDate}}至{{item.endDate | limitDate}}</p>
		  	  		<p>报名时间： {{item.registerStartDate | limitDate}}至{{item.registerEndDate | limitDate}}</p>
		  	  		<p>举办地点： {{item.provinceName}}</p>
		  	  	</div>
		  	  	 <van-button round type="danger" disabled   @click="goDetail">查看详情</van-button>
		  	  </li>
		  	</ul>
		  </van-tab>
		</van-tabs> -->
     </div>
	</div>
</template>

<script>
import vHead from "../../components/header.vue";
import {Icon,Row, Col,Button,Tab, Tabs} from 'vant';
import { mapGetters, mapState,mapActions} from "vuex";
import { getMeetingAll, getPZUrl, getNotstarted, getFinished,getStartingMeeting } from "@/api/dictionary";
export default {
  
  data() {
    return {
       active: 1,
		loading: false,
		type: "starting",
		page: 0,
		list: [],
		title:"会议中心",
    };
  },
  components: {
  	vHead,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },
	watch: {
		type(val) {
			this.page = 0;
			this.getDate()
		}
	},
  methods: {
  	...mapActions(["getGroupMemberType", "getPersonMemberType"]),
	  chufa(name,title){
	  	this.type=name;
	  },
	  go(pathName) {
	      this.$router.push({ name: pathName });
	  },
	  	  formatTime: function(dateUnix){
		  if(!dateUnix)return null;
		  let time = dateUnix.substring(0,10);
		  return time;
	  },
	 goDetail(meetingId) {
	      this.$router.push({
	        name: "MeetingDetails",
	        query:{meetingId:meetingId}
	      });
	    },
	  getDate() {
		  let func = null;
		  if(this.type === 'all') {
			  func = getMeetingAll;
		  } else if(this.type === 'ready') {
			  func = getNotstarted;
		  }else if(this.type === 'starting'){
			  func = getStartingMeeting
		  }  else {
			  func = getFinished;
		  }

		  func({}, this.page).then(res => {
			  if (res.success) {
				  let meetingList = res.result.content;
				  for(let i =0;i<meetingList.length;i++){
					  let params = {
						  id: meetingList[i].photoId
					  };
					  getPZUrl(params).then(res => {
						  meetingList[i].photoId = res.result;
					  });
				  }
				  this.list = res.result;
			  }
		  });
	  },
	  changePage: function(val) {
		  this.page = val;
		  this.getDate();
	  },
	  /*getAddress() {
		  getAddress().then(res => {
			  if (res.success) {
				  this.setAddress(res.result)
			  }
		  });
	  }*/
  },
  	computed:{
		...mapState(["userInfo"]),
		...mapGetters([ "getMemberType"])
	},
	mounted() {
		this.getDate();
		this.getPersonMemberType();
	}
};
</script>


<style lang="less" scoped>
.means{
 padding:20px 13px 15px 13px; background:url(../../assets/images/hy_bg.jpg); background-size: 100%; overflow:hidden;
.van-button{ float: right; background: #fff; color: #378be1; border:none; line-height: 26px; height: 35px;  margin-top: 8px;}
}
.portrait{ width:15%; float:left;}
.means_name{float:left; font-size:14px; color:#fff; margin-top:5px;line-height:24px; margin-left:10px;}
.more{ float:right; margin-top:8px; color:#fff;}
.means_top{ overflow: hidden; }
.mean_bottom{ font-size: 14px; color: #fff;  margin-top: 15px;
   .left_c{ float: left; line-height: 26px;}
}

.menu { padding:15px 0; border-bottom: #f2f2f2 8px solid;
.van-col{ text-align: center; 
           img{ display: block; width: 28%; margin:0 auto; }
           span{ font-size: 13px;  margin-top:10px; display:block;}
	    }
 }
.meeting_box{ 
	padding:15px; 
	img{ width: 100%; /*max-height: 5.2rem*/ height: 100%;}
	li{border-bottom:#dfdfdf solid 1px; padding-bottom: 15px; position: relative; margin-bottom: 15px;}
	.van-button{ float: right; background: #378be1; color: #fff; border:none; line-height: 26px; height: 30px;  margin-top: 8px;
		position: absolute; bottom:15px; right:0px;} 
}
.meeting_box li .imgBox{ height: 5.98rem; background: url(../../assets/images/mor.jpg); background-size:100%;
display: block; }
.fonts{ font-size: 13px; line-height: 24px; margin-top: 10px; width: 70%;}
/deep/.van-tabs__line{ z-index: 0; }
.tabbtn{ width: 100%; display: inline-flex; }
.tabbtn li{ width: 33.3%; text-align: center; font-size:14px; padding: 20px 0; border-bottom: #dfdfdf solid 2px;}
.tabbtn li.current{ border-color: red }
.content p.warmTip{ text-align: center; font-size:14px; margin-top: 50px; }
</style>
